<ion-modal [isOpen]="debuggingService.isModalOpen" (didDismiss)="debuggingService.dismissDebuggingAlert()">
	<ng-template>
		<h3>Debugging Results</h3>
		<div class="wrapper">
			<pre [innerHTML]="debuggingService.alertMessage | prettyJson: [true, 2]"></pre>
		</div>
	</ng-template>
</ion-modal>
